/* SicilyAddict DE - pulsante delle card Bundle (snippets/sa-de-bundle-card.liquid),
   in home (sections/sa-de-home-bundles.liquid) e sulle schede prodotto (sections/sa-de-pdp-bundles.liquid).
   Caricato dalle due sezioni; la guardia window.saBundlesInit evita doppi click-handler se lo script
   compare due volte nella stessa pagina.
   - Un solo POST /cart/add.js con TUTTI i prodotti del bundle: {items:[{id,quantity},...]}
     (data-items sul pulsante = prima variante disponibile di ogni prodotto x quantita' del blocco).
   - Poi evento 'product:added' su <html> con la quantita' totale: e' l'aggancio documentato del tema
     Warehouse (vedi assets/custom.js) con cui il tema ricarica e apre il carrello a scomparsa, lo stesso
     evento che usa l'upsell dello Smart Cart. Se dopo il ricaricamento ('cart:rerendered') il carrello
     non e' aperto, lo apre il pulsante carrello dell'header (come fa smart-cart-ui.js).
     Con il carrello a pagina (Impostazioni tema > cart_type = page) si va su /cart.
   - L'etichetta resta nello span .sa-i18n (Warenkorb / Carrello, assets/sa-de-i18n.js): caricamento e
     "aggiunto" sono solo classi + icone, cosi' il testo tradotto da GTranslate non si perde. */
(function () {
  'use strict';
  if (window.saBundlesInit) return;
  window.saBundlesInit = true;

  function readItems(btn) {
    var raw = btn.getAttribute('data-items');
    if (raw) {
      try {
        return JSON.parse(raw).filter(function (x) { return x && Number(x.id) > 0 && Number(x.quantity) > 0; })
          .map(function (x) { return { id: Number(x.id), quantity: Number(x.quantity) }; });
      } catch (e) { return []; }
    }
    return [];
  }

  function setStatus(btn, text, isError) {
    var card = btn.closest('.sa-gm-bundle');
    var el = card && card.querySelector('.sa-gm-bundle__status');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', !!isError);
  }

  function miniCartOpen() {
    var cart = document.getElementById('mini-cart');
    return !cart || cart.getAttribute('aria-hidden') === 'false';
  }

  function ensureMiniCartOpen() {
    var done = false;
    function check() {
      if (done) return;
      done = true;
      document.removeEventListener('cart:rerendered', onRerender);
      setTimeout(function () {
        if (miniCartOpen()) return;
        var toggle = document.querySelector('[aria-controls="mini-cart"][data-action="toggle-mini-cart"], [aria-controls="mini-cart"]');
        if (toggle) toggle.click();
      }, 350);
    }
    function onRerender() { check(); }
    document.addEventListener('cart:rerendered', onRerender);
    setTimeout(check, 2500);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-sa-bundle-add]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var items = readItems(btn);
    if (!items.length) return;
    var qty = items.reduce(function (n, x) { return n + x.quantity; }, 0);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    btn.disabled = true;
    btn.classList.remove('is-added');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setStatus(btn, '');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        btn.disabled = false;
        setStatus(btn, btn.getAttribute('data-msg-added'));

        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = root + 'cart';
          return;
        }
        ensureMiniCartOpen();
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: qty } }));
        setTimeout(function () {
          btn.classList.remove('is-added');
          setStatus(btn, '');
        }, 3000);
      })
      .catch(function (error) {
        console.error(error);
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        var message = (error && error.description) || btn.getAttribute('data-msg-error') || '';
        setStatus(btn, message, true);
      });
  });
})();
